<template>
  <el-dialog :visible.sync="visible" class="projectDialog" width="88%" :title="title" :close-on-click-modal="false" @open="getOpen" @close="close" :modal-append-to-body="false">
    <div class="titleContainer">
      <div class="titleItem" :class="{'active': activeName == 'base' }" @click="changeTab('base')">基本信息</div>
      <div class="titleItem" :class="{'active': activeName == 'content' }" @click="changeTab('content')">内容信息</div>
    </div>
    <keep-alive>
      <template v-if="activeName === 'base'">
        <div style="padding: 0; margin-top: 20px">
          <el-form :model="detail" class="addDetail" :rules="(status != 'readonly') ? rules : {}" ref="detail" label-width="130px">
            <el-form-item label="维保项目名称" prop="name">
              <el-input placeholder="请输入项目名称" v-model="detail.name" maxlength="50" class="detail_input" v-if="status === 'adding'">
              </el-input>
              <p v-else>{{ detail.name }}</p>
            </el-form-item>
            <el-form-item label="业务处理部门" prop="department">
              <el-select :popper-append-to-body="false" v-model="detail.department" placeholder="请选择业务处理部门" style="width:310px" v-if="status === 'adding'" @change="selectDepartment">
                <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <p v-else>{{ detail.processingDepartment }}</p>
            </el-form-item>
            <el-form-item label="维保单位名称" prop="departmentName">
              <el-input placeholder="请输入维保单位名称" v-model="detail.departmentName" v-if="status === 'adding'" maxlength="50" class="detail_input">
              </el-input>
              <p v-else>{{ detail.departmentName }}</p>
            </el-form-item>
            <el-form-item label="维保单位联系人" prop="departmentContacts">
              <el-input placeholder="请输入维保单位联系人" v-model="detail.departmentContacts" v-if="status != 'readonly'" maxlength="50" class="detail_input">
              </el-input>
              <p v-else>{{ detail.departmentContacts }}</p>
            </el-form-item>
            <el-form-item label="联系人手机号" prop="departmentContactsPhone">
              <el-input placeholder="请输入联系人手机号" v-model="detail.departmentContactsPhone" v-if="status != 'readonly'" class="detail_input">
              </el-input>
              <p v-else>{{ detail.departmentContactsPhone }}</p>
            </el-form-item>
            <el-form-item label="合同开始时间" prop="startTime">
              <el-date-picker v-model="detail.startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择开始时间" v-if="status === 'adding'" class="detail_input">
              </el-date-picker>
              <p v-else>{{ detail.startTime }}</p>
            </el-form-item>
            <el-form-item label="合同结束时间" prop="endTime">
              <el-date-picker v-model="detail.endTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="请选择结束时间" v-if="status != 'readonly'" class="detail_input">
              </el-date-picker>
              <p v-else>{{ detail.endTime }}</p>
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input placeholder="请输入地址" v-model="detail.address" v-if="status != 'readonly'" maxlength="50" class="detail_input">
              </el-input>
              <p v-else>{{ detail.address }}</p>
            </el-form-item>
            <el-form-item label="是否需要签名" prop="isSign">
              <el-radio-group v-model="detail.isSign" v-if="status != 'readonly'">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
              <p v-else>{{ detail.isSign == 0 ? '否' : '是' }}</p>
            </el-form-item>
            <el-form-item label="报表模板类型" prop="excelTemplateType">
              <p>{{ detail.excelTemplateType | filterExcelTemplate }}</p>
            </el-form-item>
            <el-form-item label="特定区域" prop="areas" v-if="status =='adding'">
              <el-input placeholder="请选择特定区域" @focus="checkAreas" class="detail_input" v-model="areaName"></el-input>
              <selectRegion :dialogVisible="areaTreeVisible" @regionTreeClose="areaTreeVisible = false" @sendTreeData="selRegionData" :checkAreaIds="checkAreaIds" :deptId="detail.department">
              </selectRegion>
            </el-form-item>
            <el-form-item label="特定区域" v-else-if="status !== 'adding' && detail.areas != ''">
              <span class="checkArea" @click="areaTreeDialog = true">点击查看</span>
              <region-tree v-model="areaTreeDialog" :projectId="detail.id"></region-tree>
            </el-form-item>
            <div class="tips" style="margin: 0 0 10px 70px;width: 391px;color:#fff;" v-if="status =='adding'">tips:未设置特定区域，则按照部门管理区域生成任务，选择特定区域则按照选定的特定区域生成任务。</div>
            <el-form-item label="维保合同">
              <el-upload-secondary class="YnormalCard" v-model="detail.contract" :limit="1" accepts="pdf,doc,docx,png,jpg,jpeg" v-if="status =='adding'">
                <i class="el-icon-plus"></i>
              </el-upload-secondary>
              <p v-else>
                <template v-if="detail.contract != ''">
                  <el-image :src="detail.contract" style="width:80px;height: 80px;" v-if="isHasImg" :preview-src-list="[detail.contract]">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                  <a :href="detail.contract" style="color:white" target="blank" v-else>合同</a>
                </template>
                <span v-else style="color: #b5b5b5;">暂未上传</span>
              </p>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-else>
        <div style="padding: 0; margin-top: 20px">
          <div class="formtab">
            <el-form>
              <el-form-item label="选择模板" prop="templateId" v-if="status =='adding'">
                <el-select v-model="templateId" placeholder="请选择模板" :popper-append-to-body="false" @change="changeTemplate">
                  <el-option v-for="item in templateList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="楼宇类型" prop="buildType" v-if="companyType != 3">
                <el-radio-group v-model="detail.buildType" v-if="status =='adding'">
                  <el-radio label="低层">低层</el-radio>
                  <el-radio label="高层">高层</el-radio>
                </el-radio-group>
                <p v-else>{{ detail.buildType }}</p>
              </el-form-item>
              <el-form-item label="项目类型" prop="type" v-if="companyType != 3" key="indType">
                <el-radio-group v-model="detail.type" v-if="status == 'adding'">
                  <el-radio label="月检">月检</el-radio>
                  <el-radio label="季检">季检</el-radio>
                  <el-radio label="年检">年检</el-radio>
                </el-radio-group>
                <p v-else>{{ detail.type }}</p>
              </el-form-item>
              <el-form-item label="项目类型" prop="type" v-else key="noIndType">
                <el-radio-group v-model="detail.type" v-if="status == 'adding'">
                  <el-radio label="日检">日检</el-radio>
                  <el-radio label="周检">周检</el-radio>
                  <el-radio label="月检">月检</el-radio>
                  <el-radio label="季检">季检</el-radio>
                  <el-radio label="年检">年检</el-radio>
                </el-radio-group>
                <p v-else>{{ detail.type }}</p>
              </el-form-item>
              <el-form-item label="维保周期" v-if="detail.type != '日检' && detail.type != '周检'" key="indCycle">
                <el-checkbox-group v-model="checkMonth" v-if="status == 'adding'">
                  <el-checkbox v-for="(item,index) in monthArr" :key="index" :label="item.value">{{ item.label }}</el-checkbox>
                </el-checkbox-group>
                <p v-else>
                  <span v-for="(item, index) in checkMonth" :key="index" style="margin-right: 20px;">{{ item }}月</span>
                </p>
              </el-form-item>
              <el-form-item label="维保周期" v-if="detail.type == '日检'" key="dayCircle">
                <el-checkbox-group v-model="checkMonth" v-if="status == 'adding'">
                  <el-checkbox v-for="(item,index) in dayArr" :key="index" :label="item.value">{{ item.label }}</el-checkbox>
                </el-checkbox-group>
                <p v-else>
                  <span v-for="(item, index) in checkMonth" :key="index" style="margin-right: 20px;">{{ item }}时</span>
                </p>
              </el-form-item>
              <el-form-item label="维保周期" v-if="detail.type == '周检'" key="weekCircle">
                <el-checkbox-group v-model="checkMonth" v-if="status == 'adding'">
                  <el-checkbox v-for="(item,index) in weekArr" :key="index" :label="item.value">{{ item.label }}</el-checkbox>
                </el-checkbox-group>
                <p v-else>
                  <span v-for="(item, index) in checkMonth" :key="index" style="margin-right: 20px;">{{ item }}</span>
                </p>
              </el-form-item>
              <el-form-item label="维保项目内容配置" style="margin-bottom: 10px;"></el-form-item>
            </el-form>
            <template v-if="status =='adding'">
              <el-form ref="dynamicValidateForm" class="demo-dynamic">
                <div class="dynamic-container">
                  <div>
                    <el-form-item :label="'部位(必填)'" style="display:inline-block;margin-bottom:0px;width:1.4rem"></el-form-item>
                    <el-form-item :label="'消防系统(必选)'" style="display:inline-block;margin-bottom:0px;width:1.7rem"></el-form-item>
                    <el-form-item :label="'巡检内容(必填)'" style="display:inline-block;margin-bottom:0px;width:1.7rem"></el-form-item>
                    <el-form-item :label="'建设交付情况'" style="display:inline-block;margin-bottom:0px;width:1.7rem"></el-form-item>
                    <el-form-item :label="'检查标准(必填)'" style="display:inline-block;margin-bottom:0px;width:1.7rem"></el-form-item>
                    <el-form-item :label="'检查方法(必填)'" style="display:inline-block;margin-bottom:0px;width:1.4rem"></el-form-item>
                    <el-form-item :label="'检查结果(必填)'" style="display:inline-block;margin-bottom:0px;width:1.7rem"></el-form-item>
                    <el-form-item :label="'检查结果规则(必填)'" style="display:inline-block;margin-bottom:0px;width:1.4rem"></el-form-item>
                    <el-form-item :label="'检查结果展现规则'" style="display:inline-block;margin-bottom:0px;width:1.7rem"></el-form-item>
                  </div>
                  <el-form-item v-for="(domain, index) in dynamicValidateForm" :key="domain.key" :prop="dynamicValidateForm.position">
                    <el-input class="d_names" v-model="domain.position" placeholder="部位" maxlength="200"></el-input>
                    <el-form-item :prop="'dynamicValidateForm.' + index + '.fireControlSystem'" style="display:inline-block">
                      <el-select v-model="domain.fireControlSystem" placeholder="消防系统" style="width: 1.65rem;" @change="changeFireSystem($event, index)" filterable>
                        <el-option v-for="item in systemList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item :prop="'dynamicValidateForm.' + index + '.patrolContent'" style="display:inline-block">
                      <el-select v-model="domain.patrolContent" placeholder="巡检内容" style="width: 1.65rem;" filterable :filter-method="(value) => filterContent(value, index)"
                        @change="changePatrolContent($event, index)">
                        <el-option v-for="item in dynamicValidateForm[index].patrolContentList" :key="item.id" :label="item.patrolContent" :value="item.patrolContent"></el-option>
                      </el-select>
                      <!-- <el-input class="d_datas" v-model="domain.patrolContent" placeholder="" maxlength="200"></el-input> -->
                    </el-form-item>
                    <el-form-item :prop="'dynamicValidateForm.' + index + '.deliverContent'" style="display:inline-block">
                      <el-input class="d_datas" v-model="domain.deliverContent" placeholder="建设交付情况" maxlength="200"></el-input>
                    </el-form-item>
                    <el-form-item :prop="'dynamicValidateForm.' + index + '.inspectionStandard'" style="display:inline-block">
                      <el-input class="d_datas" v-model="domain.inspectionStandard" placeholder="检查标准" maxlength="200"></el-input>
                    </el-form-item>
                    <el-form-item :prop="'dynamicValidateForm.' + index + '.inspectionMethod'" style="display:inline-block">
                      <el-input v-model="domain.inspectionMethod" placeholder="检查方法" maxlength="200" style="width: 1.4rem;"></el-input>
                    </el-form-item>
                    <el-form-item :prop="'dynamicValidateForm.' + index + '.result'" style="display:inline-block">
                      <el-input class="d_datas" v-model="domain.result" placeholder="检查结果" maxlength="200"></el-input>
                    </el-form-item>
                    <el-form-item :prop="'dynamicValidateForm.' + index + '.resultRegulation'" style="display:inline-block">
                      <el-input v-model="domain.resultRegulation" placeholder="检查结果规则" maxlength="200" style="width: 1.4rem;"></el-input>
                    </el-form-item>
                    <el-form-item :prop="'dynamicValidateForm.' + index + '.resultRule'" style="display:inline-block">
                      <el-input class="d_datas" v-model="domain.resultRule" placeholder="检查结果展现规则" maxlength="200"></el-input>
                    </el-form-item>
                    <el-button type="success" icon="el-icon-top" @click.prevent="ascendOrder(index)" style="margin-left: 10px" class="operationBtn"></el-button>
                    <el-button type="success" icon="el-icon-bottom" @click.prevent="descOrder(index)" class="operationBtn"></el-button>
                    <el-button type="danger" @click.prevent="removeDomain(domain)" class="operationBtn">删除</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button class="d_add_data" type="success" @click="addDomain">新增巡检项</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </template>
            <template v-else>
              <el-table :data="dynamicValidateForm" style="margin:20px 0" class="stripeTable" height="220" ref="Table">
                <el-table-column label="部位" prop="position" show-overflow-tooltip></el-table-column>
                <el-table-column label="消防系统" prop="fireControlSystem" show-overflow-tooltip></el-table-column>
                <el-table-column label="巡检内容" prop="patrolContent" show-overflow-tooltip></el-table-column>
                <el-table-column label="建设交付情况" prop="deliverContent" show-overflow-tooltip></el-table-column>
                <el-table-column label="检查标准" prop="inspectionStandard" show-overflow-tooltip></el-table-column>
                <el-table-column label="检查方法" prop="inspectionMethod" show-overflow-tooltip></el-table-column>
                <el-table-column label="检查结果" prop="result" show-overflow-tooltip></el-table-column>
                <el-table-column label="检查结果规则" prop="resultRegulation" show-overflow-tooltip></el-table-column>
                <el-table-column label="检查结果展示规则" prop="resultRule" show-overflow-tooltip></el-table-column>
              </el-table>
            </template>
          </div>
        </div>
      </template>
    </keep-alive>

    <p style="margin-top: 30px; display: flex; justify-content: flex-end" v-if="status != 'readonly'">
      <template v-if="activeName === 'base'">
        <button class='w_next_button cancelButton' @click.prevent="cancel">取消</button>
        <button class='w_next_button confirmButton' style="margin-left: 20px" @click.prevent="next">下一步</button>
      </template>
      <template v-if="activeName === 'content'">
        <button class='w_next_button cancelButton' @click.prevent="activeName = 'base'">上一步</button>
        <button class='w_next_button confirmButton' style="margin-left: 20px" @click.prevent="confirmSubmit">确认</button>
      </template>
    </p>
  </el-dialog>
</template>

<script>
import { date } from 'utils'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'adding'
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      activeName: 'base',
      step: 0,
      isShow: false,
      dynamicValidateForm: [],
      detail: {},
      visible: this.value,
      checkMonth: [],
      dayArr: [],
      weekArr: [
        {
          label: '周一',
          value: '周一'
        },
        {
          label: '周二',
          value: '周二'
        },
        {
          label: '周三',
          value: '周三'
        },
        {
          label: '周四',
          value: '周四'
        },
        {
          label: '周五',
          value: '周五'
        },
        {
          label: '周六',
          value: '周六'
        },
        {
          label: '周日',
          value: '周日'
        }
      ],
      monthArr: [
        {
          label: '1月',
          value: '1'
        },
        {
          label: '2月',
          value: '2'
        },
        {
          label: '3月',
          value: '3'
        },
        {
          label: '4月',
          value: '4'
        },
        {
          label: '5月',
          value: '5'
        },
        {
          label: '6月',
          value: '6'
        },
        {
          label: '7月',
          value: '7'
        },
        {
          label: '8月',
          value: '8'
        },
        {
          label: '9月',
          value: '9'
        },
        {
          label: '10月',
          value: '10'
        },
        {
          label: '11月',
          value: '11'
        },
        {
          label: '12月',
          value: '12'
        }
      ],
      departmentList: [],
      templateList: [],
      areaTreeVisible: false,
      areaName: '',
      checkAreaIds: [],
      templateId: '',
      isHasImg: false,
      excelTemplateTypeList: [
        {
          label: '社区',
          value: 1
        },
        {
          label: '高校',
          value: 2
        },
        {
          label: '工业',
          value: 3
        },
        {
          label: '其他',
          value: 9
        }
      ],
      self: '',
      companyType: localStorage.getItem('companyType'),
      systemList: [],
      areaTreeDialog: false
    }
  },
  watch: {
    value(val) {
      self = this
      this.setCurrentValue(val)
    },
    visible(value) {
      this.$emit('input', value)
    }
  },
  components: {
    selectRegion: () => import('../selectRegion'),
    regionTree: () => import('./regionTree')
  },
  computed: {
    title() {
      if (this.status == 'adding') {
        return '新增'
      } else if (this.status == 'editing') {
        return '编辑'
      } else if (this.status == 'readonly') {
        return '详情'
      }
    },
    rules() {
      return {
        name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        department: [
          { required: true, message: '请选择业务处理部门', trigger: 'change' }
        ],
        departmentName: [
          { required: true, message: '请输入维保单位名称', trigger: 'blur' }
        ],
        departmentContacts: [
          { required: true, message: '请输入维保单位联系人', trigger: 'blur' }
        ],
        departmentContactsPhone: [
          { required: true, message: '请输入联系人手机号', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (!/^[1]\d{10}$/.test(value)) {
                callback(new Error('手机号格式错误'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (this.status == 'readonly') return
              if (!value) {
                return callback(new Error('合同结束时间不能为空'))
              }
              if (!this.isMaxGtMin) {
                return callback(new Error('结束时间要大于开始时间'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.status == 'readonly') return
              if (!value) {
                return callback(new Error('合同结束时间不能为空'))
              }
              if (!this.isMaxGtMin) {
                return callback(new Error('结束时间要大于开始时间'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }]
      }
    },
    isMaxGtMin() {
      if (!this.detail.startTime || !this.detail.endTime) return true
      let s = date(this.detail.startTime)
      let e = date(this.detail.endTime)
      let ns = [s.YY, s.MM, s.DD].join('')
      let ne = [e.YY, e.MM, e.DD].join('')
      return ne > ns ? true : false
    }
  },
  filters: {
    filterExcelTemplate(value) {
      if (self.visible) {
        console.log(value)
        let item = self.excelTemplateTypeList.find(
          (item) => item.value == value
        )
        return item ? item.label : ''
      }
    }
  },
  mounted() {
    let arr = []
    for (let i = 0; i < 24; i++) {
      let obj = {
        label: `${i}时`,
        value: i
      }
      arr.push(obj)
    }
    this.dayArr = arr
  },
  methods: {
    setCurrentValue(val) {
      let data = this.data
      this.templateId = ''
      if (this.status != 'readonly') {
        this.getDepartmentList()
      }
      if (this.status != 'adding') {
        this.$axiosget('extra/maintenanceProject/item', {
          params: {
            projectId: data.id
          }
        }).then((res) => {
          this.detail = data

          if (
            ['png', 'jpg', 'jpeg'].includes(
              this.detail.contract.substr(
                this.detail.contract.lastIndexOf('.') + 1
              )
            )
          ) {
            let fileUrl = process.env.fileUrl
            if (
              this.detail.contract &&
              this.detail.contract.includes(fileUrl)
            ) {
              if (process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true') {
                this.detail.contract = this.detail.contract.replaceAll(
                  fileUrl,
                  process.env.SSL_HOST + '/file/'
                )
              }
            }
            this.isHasImg = true
          } else {
            this.isHasImg = false
          }
          if (this.status === 'editing') {
            this.$axiosget('extra/maintenanceTemplate').then((res) => {
              this.templateList = res.data.data
            })
          }
          this.dynamicValidateForm = res.data.data
          this.visible = val
          this.checkMonth = this.detail.months.split(',')
          // if (this.detail.areas) {
          //   console.log(this.detail.areas, '----------')
          //   let cloneAreas = _.cloneDeep(this.detail.areas)
          //   console.log(cloneAreas)
          //   let areas = cloneAreas.split(',')
          //   console.log(areas)
          //   this.$axiosget('operation/deptApi/getAreaTreeByUser', {
          //     params: {
          //       deptId: this.detail.department
          //     }
          //   }).then((res) => {
          //     let res1 = res.data.data || []
          //     if (res1 && res1.length) {
          //       let areaData = res1
          //       let getTreeName = function (list, id) {
          //         for (let i = 0; i < list.length; i++) {
          //           let a = list[i]
          //           if (a.id === id) {
          //             return a.name
          //           } else {
          //             if (a.areas && a.areas.length > 0) {
          //               let res = getTreeName(a.areas, id)
          //               if (res) {
          //                 return res
          //               }
          //             }
          //           }
          //         }
          //       }
          //       let nameArr = []
          //       areas.forEach((item) => {
          //         nameArr.push(getTreeName(areaData, Number(item)))
          //       })
          //       console.log(nameArr)
          //     }
          //   })
          //   this.visible = val
          //   this.checkMonth = this.detail.months.split(',')
          // } else {
          //   this.visible = val
          //   this.checkMonth = this.detail.months.split(',')
          // }
        })
      } else {
        this.getSystemList()
        this.getTemplateList()
        this.dynamicValidateForm = []
        this.visible = val
        this.detail = {
          excelTemplateType: this.companyType,
          isSign: 0,
          buildType: this.companyType == 3 ? '其他' : null
        }
        this.detail.contract = undefined
        this.checkMonth = []
      }
    },
    getSystemList() {
      this.$axiosget('operation/dictionaryType/queryByKey', {
        params: {
          key: 'fireControlSystem'
        }
      }).then((res) => {
        if (res.data.status === '10000') {
          this.systemList = res.data.data ? res.data.data.list : []
        }
      })
    },
    changeTemplate(id) {
      let item = this.templateList.find((item) => item.id == id)
      this.$set(this.detail, 'buildType', item.buildType)
      this.$set(this.detail, 'type', item.type)
      this.confirmExport()
    },
    // 获取模板列表
    getTemplateList() {
      this.$axiosget('extra/maintenanceTemplate').then((res) => {
        this.templateList = res.data.data
      })
    },
    // 获取处理部门列表
    getDepartmentList() {
      this.$axiosget('operation/deptApi/getDeptList').then((res) => {
        this.departmentList = res.data.data[0].children
      })
    },
    selectDepartment(val) {
      this.detail.processingDepartment =
        this.departmentList.find((item) => item.id == val).name || ''
      let departmentName =
        this.departmentList.find((item) => item.id == val).name || ''
      this.$set(this.detail, 'departmentName', departmentName)
      this.checkAreaIds = []
      this.detail.areas = ''
      this.areaName = ''
    },
    checkAreas() {
      if (this.detail.areas) {
        this.checkAreaIds = this.detail.areas.split(',')
      }
      this.areaTreeVisible = true
    },
    selRegionData(id, name) {
      this.detail.areas = id.join(',')
      this.areaName = name
    },
    // 确认导入
    confirmExport() {
      if (!this.templateId) {
        this.$notify({
          message: '请先选择模板',
          type: 'warning'
        })
        return
      }
      this.$axiosget('extra/maintenanceTemplate/item', {
        params: {
          templateId: this.templateId
        }
      }).then((res) => {
        if (res.data.data.length != 0) {
          this.dynamicValidateForm = res.data.data.map((item) => {
            return {
              ...item,
              result: item.inspectionResult,
              resultRegulation: item.inspectionResultRule,
              patrolContentList: []
            }
          })
        } else {
          this.$notify({
            message: '模板中暂未添加模板项',
            type: 'warning'
          })
          this.dynamicValidateForm = []
        }
      })
    },
    getPatrolContentList(event) {
      this.$axiosget('extra/maintenanceContentItem/getListByFireSystem', {
        params: {
          fireControlSystem: event
        }
      }).then((res) => {
        if (res.data.status == 10000) {
          return res.data.data
        }
      })
    },
    changeTab(val) {
      if (this.status == 'readonly') {
        this.activeName = val
      }
    },
    getOpen() {
      this.$nextTick(() => {
        this.$refs.detail.clearValidate()
      })
    },
    close() {
      this.detail = {}
      this.activeName = 'base'
      this.areaName = ''
      this.checkMonth = []
      this.checkAreaIds = []
      this.templateList = []
      this.isHasImg = false
      if (this.activeName == 'base') {
        this.$nextTick(() => {
          this.$refs.detail.resetFields()
        })
      }
      this.dynamicValidateForm = []
    },
    changeFireSystem(event, index) {
      if (event) {
        this.dynamicValidateForm[index].patrolContent = ''
        this.dynamicValidateForm[index].inspectionStandard = ''
        this.dynamicValidateForm[index].resultRegulation = ''
        this.dynamicValidateForm[index].result = ''
        this.dynamicValidateForm[index].inspectionMethod = ''
        this.$axiosget('extra/maintenanceContentItem/getListByFireSystem', {
          params: {
            fireControlSystem: event
          }
        }).then((res) => {
          if (res.data.status == 10000) {
            this.dynamicValidateForm[index].patrolContentList = res.data.data
              ? res.data.data
              : []
          }
        })
      }
    },
    filterContent(value, index) {
      this.dynamicValidateForm[index].patrolContent = value
      let patrolContentList = this.dynamicValidateForm[
        index
      ].patrolContentList.filter((item) => {
        if (
          !!~item.patrolContent.indexOf(value) ||
          !!~item.patrolContent.toUpperCase().indexOf(value.toUpperCase())
        ) {
          return true
        }
      })
      if (value && patrolContentList.length) {
        this.dynamicValidateForm[index].patrolContentList =
          this.dynamicValidateForm[index].patrolContentList.filter((item) => {
            if (
              !!~item.patrolContent.indexOf(value) ||
              !!~item.patrolContent.toUpperCase().indexOf(value.toUpperCase())
            ) {
              return true
            }
          })
      }
    },
    changePatrolContent(event, index) {
      this.dynamicValidateForm[index].inspectionMethod =
        this.dynamicValidateForm[index].patrolContentList.find(
          (item) => item.patrolContent == event
        )
          ? this.dynamicValidateForm[index].patrolContentList.find(
              (item) => item.patrolContent == event
            ).inspectionMethod
          : ''
      this.dynamicValidateForm[index].inspectionStandard =
        this.dynamicValidateForm[index].patrolContentList.find(
          (item) => item.patrolContent == event
        )
          ? this.dynamicValidateForm[index].patrolContentList.find(
              (item) => item.patrolContent == event
            ).inspectionStandard
          : ''
      this.dynamicValidateForm[index].resultRegulation =
        this.dynamicValidateForm[index].patrolContentList.find(
          (item) => item.patrolContent == event
        )
          ? this.dynamicValidateForm[index].patrolContentList.find(
              (item) => item.patrolContent == event
            ).inspectionResultRule
          : ''
      this.dynamicValidateForm[index].result = this.dynamicValidateForm[
        index
      ].patrolContentList.find((item) => item.patrolContent == event)
        ? this.dynamicValidateForm[index].patrolContentList.find(
            (item) => item.patrolContent == event
          ).inspectionResult
        : ''
    },
    addDomain(item) {
      this.dynamicValidateForm.push({
        position: '',
        patrolContent: '',
        inspectionStandard: '',
        inspectionMethod: '',
        deliverContent: '',
        result: '',
        resultRule: '',
        serialNumber: '',
        resultRegulation: '',
        maintenanceContentItemId: '',
        fireControlSystem: '',
        patrolContentList: []
      })
    },
    ascendOrder(index, item) {
      let upGo = (fieldData, index) => {
        if (index != 0) {
          fieldData[index] = fieldData.splice(index - 1, 1, fieldData[index])[0]
        } else {
          fieldData.push(fieldData.shift())
        }
      }
      if (index !== 0) {
        upGo(this.dynamicValidateForm, index)
      }
    },
    descOrder(index) {
      let downGo = (fieldData, index) => {
        if (index != fieldData.length - 1) {
          fieldData[index] = fieldData.splice(index + 1, 1, fieldData[index])[0]
        } else {
          fieldData.unshift(fieldData.splice(index, 1)[0])
        }
      }
      if (index !== this.dynamicValidateForm.length - 1) {
        downGo(this.dynamicValidateForm, index)
      }
    },
    removeDomain(item) {
      let index = this.dynamicValidateForm.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.splice(index, 1)
      }
    },
    cancel() {
      this.visible = false
      this.close()
    },
    next() {
      this.$refs.detail.validate((valid) => {
        if (valid) {
          this.activeName = 'content'
        }
      })
    },
    confirmSubmit() {
      if (
        !this.detail.type ||
        !this.detail.buildType ||
        !this.checkMonth.length ||
        !this.dynamicValidateForm.length
      ) {
        this.$notify({
          message: '请填写项目类型或选择月份或者楼宇类型或填写维保项目内容',
          type: 'warning'
        })
        return
      }
      let isHasName = this.dynamicValidateForm.every((item) => item.position)
      let isHasContent = this.dynamicValidateForm.every(
        (item) => item.patrolContent
      )
      let isHasResult = this.dynamicValidateForm.every((item) => item.result)
      let isHasFireControlSystem = this.dynamicValidateForm.every(
        (item) => item.fireControlSystem
      )
      let isHasInspectionStandard = this.dynamicValidateForm.every(
        (item) => item.inspectionStandard
      )
      let isHasInspectionMethod = this.dynamicValidateForm.every(
        (item) => item.inspectionMethod
      )

      let isHasResultRegulation = this.dynamicValidateForm.every(
        (item) => item.resultRegulation
      )
      if (
        !isHasName ||
        !isHasContent ||
        !isHasResult ||
        !isHasInspectionStandard ||
        !isHasInspectionMethod ||
        !isHasResultRegulation ||
        !isHasFireControlSystem
      ) {
        this.$notify({
          message: '请把必填项填写完整',
          type: 'warning'
        })
        return
      }
      if (this.dynamicValidateForm.length) {
        this.dynamicValidateForm.forEach((item, index) => {
          item.serialNumber = index
        })
      }

      if (this.status == 'adding') {
        this.$axiospost('extra/maintenanceProject', {
          ...this.detail,
          months: this.checkMonth.join(','),
          contract:
            this.detail.contract != undefined
              ? this.detail.contract
                  .map((item) =>
                    item.response.data[0].startsWith('http')
                      ? item.response.data[0]
                      : process.env.fileUrl + '/' + item.response.data[0]
                  )
                  .join(',')
              : '',
          item: [...this.dynamicValidateForm]
        }).then((res) => {
          this.$message.success('提交成功')
          this.cancel()
          this.$emit('refresh')
        })
      } else {
        this.$axiosput('extra/maintenanceProject', {
          ...this.detail,
          months: this.checkMonth.join(','),
          contract: this.detail.contract.length
            ? this.detail.contract
                .map((item) =>
                  item.response.data[0].startsWith('http')
                    ? item.response.data[0]
                    : process.env.fileUrl + '/' + item.response.data[0]
                )
                .join(',')
            : '',
          item: [...this.dynamicValidateForm]
        }).then((res) => {
          this.$message.success('修改成功')
          this.cancel()
          this.$emit('refresh')
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.titleContainer {
  display: flex;
  background: #2e3657;
  border: 1px solid #214c71;

  & > div {
    width: 100px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #c0c4cc;
    cursor: pointer;

    &.active {
      background: #262d4a;
      color: #409eff;
    }
  }
}

.d_names {
  width: 1.4rem;
}

.d_datas {
  width: 1.7rem;
}

/deep/ .el-form-item__content {
  margin-left: 0 !important;
}

.demo-dynamic {
  width: 90%;
  margin-left: 20px;
  overflow: hidden;
  overflow-x: auto;
  white-space: nowrap;

  @media (max-width: 1680px) {
    /deep/ .el-form-item__label {
      font-size: 0.14rem;
    }
  }

  .dynamic-container {
    overflow-x: scroll !important;
  }

  .dynamic-container::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .dynamic-container::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(127, 127, 127, 0.2);
  }
  .dynamic-container::-webkit-scrollbar-track {
    border-radius: 0;
    background: rgba(127, 127, 127, 0.1);
  }

  .dynamic-container::-webkit-scrollbar {
    width: 4px;
  }
}

.detail_input {
  width: 310px;
}

/deep/ .detailForm {
  display: flex;
  align-items: center;
}
/deep/ .detailForm .el-form-item__content {
  display: flex;
  align-items: center;
}

.operationBtn {
  width: 40px;
  height: 40px;
  padding: 0;
}

.checkArea:hover {
  color: #409eff;
  border-bottom: 1px solid #409eff;
  cursor: pointer;
}
</style>

<style lang="less">
.projectDialog {
  .YnormalCard .el-upload--picture-card,
  .YnormalCard .el-upload--text,
  .YnormalCard .el-upload-list--picture-card,
  .YnormalCard .el-upload-list--picture-card .el-upload-list__item {
    width: 80px !important;
    height: 80px !important;
  }

  .YnormalCard .el-upload--text {
    background: #ffffff38;
  }

  .YnormalCard .el-upload--picture-card i,
  .YnormalCard .el-upload--text i {
    line-height: 80px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/wbManage/wbProject/modal/index.vue